import { withInstall } from '@tni-plus/utils'

import Button from './src/Button.vue'

export const TpButton = withInstall(Button)

export default TpButton

export * from './src/button'
